// Generated by Melange

import * as JitsuReact from "@jitsu/jitsu-react";
import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__ErrorPage from "../../../pages/ErrorPage.js";
import * as Buhta_cabinet__Kassa from "../../../grpc/Kassa.js";
import * as Buhta_cabinet__Kkm from "../../../models/Kkm.js";
import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_cabinet__Route from "../../../Route.js";
import * as Buhta_cabinet__SidebarItem from "./SidebarItem.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Auth from "../../../../../../packages/core/lib/Auth.js";
import * as Buhta_core__GrpcState from "../../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../../packages/core/lib/Tenant.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(currentRoute) {
  return function (org) {
    return function (kkm) {
      return function (contextRoute) {
        const match = React.useState(function () {
              return false;
            });
        const setKkmMenu = match[1];
        const kkmMenu = match[0];
        React.useEffect((function () {
                let exit = 0;
                let kkmId;
                if (typeof currentRoute !== "number") {
                  switch (currentRoute.TAG | 0) {
                    case /* Org */6 :
                        const match = currentRoute._1;
                        if (typeof match !== "number" && match.TAG === /* Kassa */2) {
                          const match$1 = match._0._0;
                          if (typeof match$1 !== "number") {
                            kkmId = match$1._0;
                            exit = 1;
                          }
                          
                        }
                        break;
                    case /* Admin */7 :
                        const match$2 = currentRoute._0;
                        if (typeof match$2 !== "number" && match$2.TAG === /* Orgs */1) {
                          const match$3 = match$2._0;
                          if (typeof match$3 !== "number") {
                            const match$4 = match$3._1;
                            if (typeof match$4 !== "number" && match$4.TAG === /* Kassa */2) {
                              const match$5 = match$4._0._0;
                              if (typeof match$5 !== "number") {
                                kkmId = match$5._0;
                                exit = 1;
                              }
                              
                            }
                            
                          }
                          
                        }
                        break;
                    default:
                      
                  }
                }
                if (exit === 1) {
                  if (kkmId === kkm.id) {
                    Curry._1(setKkmMenu, (function (param) {
                            return true;
                          }));
                  }
                  
                }
                
              }), [currentRoute]);
        let tmp;
        let exit = 0;
        let kkmId;
        if (typeof currentRoute === "number") {
          exit = 1;
        } else {
          switch (currentRoute.TAG | 0) {
            case /* Org */6 :
                const match$1 = currentRoute._1;
                if (typeof match$1 === "number" || match$1.TAG !== /* Kassa */2) {
                  exit = 1;
                } else {
                  const match$2 = match$1._0._0;
                  if (typeof match$2 === "number") {
                    exit = 1;
                  } else {
                    kkmId = match$2._0;
                    exit = 2;
                  }
                }
                break;
            case /* Admin */7 :
                const match$3 = currentRoute._0;
                if (typeof match$3 === "number" || match$3.TAG !== /* Orgs */1) {
                  exit = 1;
                } else {
                  const match$4 = match$3._0;
                  if (typeof match$4 === "number") {
                    exit = 1;
                  } else {
                    const match$5 = match$4._1;
                    if (typeof match$5 === "number" || match$5.TAG !== /* Kassa */2) {
                      exit = 1;
                    } else {
                      const match$6 = match$5._0._0;
                      if (typeof match$6 === "number") {
                        exit = 1;
                      } else {
                        kkmId = match$6._0;
                        exit = 2;
                      }
                    }
                  }
                }
                break;
            default:
              exit = 1;
          }
        }
        switch (exit) {
          case 1 :
              tmp = JsxRuntime.jsx("img", {
                    className: "w-5 h-5",
                    src: StaticAsset.src("/static/icons/cashbox.svg")
                  });
              break;
          case 2 :
              tmp = kkmId === kkm.id ? JsxRuntime.jsx("img", {
                      className: "w-5 h-5",
                      src: StaticAsset.src("/static/icons/cashbox-white.svg")
                    }) : JsxRuntime.jsx("img", {
                      className: "w-5 h-5",
                      src: StaticAsset.src("/static/icons/cashbox.svg")
                    });
              break;
          
        }
        let tmp$1;
        let exit$1 = 0;
        let kkmId$1;
        if (typeof currentRoute === "number") {
          tmp$1 = "text-gray-medium";
        } else {
          switch (currentRoute.TAG | 0) {
            case /* Org */6 :
                const match$7 = currentRoute._1;
                if (typeof match$7 === "number" || match$7.TAG !== /* Kassa */2) {
                  tmp$1 = "text-gray-medium";
                } else {
                  const match$8 = match$7._0._0;
                  if (typeof match$8 === "number") {
                    tmp$1 = "text-gray-medium";
                  } else {
                    kkmId$1 = match$8._0;
                    exit$1 = 1;
                  }
                }
                break;
            case /* Admin */7 :
                const match$9 = currentRoute._0;
                if (typeof match$9 === "number" || match$9.TAG !== /* Orgs */1) {
                  tmp$1 = "text-gray-medium";
                } else {
                  const match$10 = match$9._0;
                  if (typeof match$10 === "number") {
                    tmp$1 = "text-gray-medium";
                  } else {
                    const match$11 = match$10._1;
                    if (typeof match$11 === "number" || match$11.TAG !== /* Kassa */2) {
                      tmp$1 = "text-gray-medium";
                    } else {
                      const match$12 = match$11._0._0;
                      if (typeof match$12 === "number") {
                        tmp$1 = "text-gray-medium";
                      } else {
                        kkmId$1 = match$12._0;
                        exit$1 = 1;
                      }
                    }
                  }
                }
                break;
            default:
              tmp$1 = "text-gray-medium";
          }
        }
        if (exit$1 === 1) {
          tmp$1 = kkmId$1 === kkm.id ? "text-white" : "text-gray-medium";
        }
        let tmp$2;
        let exit$2 = 0;
        let kkmId$2;
        if (typeof currentRoute === "number") {
          tmp$2 = "";
        } else {
          switch (currentRoute.TAG | 0) {
            case /* Org */6 :
                const match$13 = currentRoute._1;
                if (typeof match$13 === "number" || match$13.TAG !== /* Kassa */2) {
                  tmp$2 = "";
                } else {
                  const match$14 = match$13._0._0;
                  if (typeof match$14 === "number") {
                    tmp$2 = "";
                  } else {
                    let tmp$3 = match$14._1;
                    if (typeof tmp$3 === "number" || tmp$3.TAG !== /* Receipts */1) {
                      tmp$2 = "";
                    } else {
                      kkmId$2 = match$14._0;
                      exit$2 = 1;
                    }
                  }
                }
                break;
            case /* Admin */7 :
                const match$15 = currentRoute._0;
                if (typeof match$15 === "number" || match$15.TAG !== /* Orgs */1) {
                  tmp$2 = "";
                } else {
                  const match$16 = match$15._0;
                  if (typeof match$16 === "number") {
                    tmp$2 = "";
                  } else {
                    const match$17 = match$16._1;
                    if (typeof match$17 === "number" || match$17.TAG !== /* Kassa */2) {
                      tmp$2 = "";
                    } else {
                      const match$18 = match$17._0._0;
                      if (typeof match$18 === "number") {
                        tmp$2 = "";
                      } else {
                        let tmp$4 = match$18._1;
                        if (typeof tmp$4 === "number" || tmp$4.TAG !== /* Receipts */1) {
                          tmp$2 = "";
                        } else {
                          kkmId$2 = match$18._0;
                          exit$2 = 1;
                        }
                      }
                    }
                  }
                }
                break;
            default:
              tmp$2 = "";
          }
        }
        if (exit$2 === 1) {
          tmp$2 = kkmId$2 === kkm.id ? "bg-white-8%" : "";
        }
        let tmp$5;
        let exit$3 = 0;
        let kkmId$3;
        if (typeof currentRoute === "number") {
          tmp$5 = "text-gray-medium";
        } else {
          switch (currentRoute.TAG | 0) {
            case /* Org */6 :
                const match$19 = currentRoute._1;
                if (typeof match$19 === "number" || match$19.TAG !== /* Kassa */2) {
                  tmp$5 = "text-gray-medium";
                } else {
                  const match$20 = match$19._0._0;
                  if (typeof match$20 === "number") {
                    tmp$5 = "text-gray-medium";
                  } else {
                    let tmp$6 = match$20._1;
                    if (typeof tmp$6 === "number" || tmp$6.TAG !== /* Receipts */1) {
                      tmp$5 = "text-gray-medium";
                    } else {
                      kkmId$3 = match$20._0;
                      exit$3 = 1;
                    }
                  }
                }
                break;
            case /* Admin */7 :
                const match$21 = currentRoute._0;
                if (typeof match$21 === "number" || match$21.TAG !== /* Orgs */1) {
                  tmp$5 = "text-gray-medium";
                } else {
                  const match$22 = match$21._0;
                  if (typeof match$22 === "number") {
                    tmp$5 = "text-gray-medium";
                  } else {
                    const match$23 = match$22._1;
                    if (typeof match$23 === "number" || match$23.TAG !== /* Kassa */2) {
                      tmp$5 = "text-gray-medium";
                    } else {
                      const match$24 = match$23._0._0;
                      if (typeof match$24 === "number") {
                        tmp$5 = "text-gray-medium";
                      } else {
                        let tmp$7 = match$24._1;
                        if (typeof tmp$7 === "number" || tmp$7.TAG !== /* Receipts */1) {
                          tmp$5 = "text-gray-medium";
                        } else {
                          kkmId$3 = match$24._0;
                          exit$3 = 1;
                        }
                      }
                    }
                  }
                }
                break;
            default:
              tmp$5 = "text-gray-medium";
          }
        }
        if (exit$3 === 1) {
          tmp$5 = kkmId$3 === kkm.id ? "text-white" : "text-gray-medium";
        }
        let tmp$8;
        let exit$4 = 0;
        let kkmId$4;
        if (typeof currentRoute === "number") {
          tmp$8 = "";
        } else {
          switch (currentRoute.TAG | 0) {
            case /* Org */6 :
                const match$25 = currentRoute._1;
                if (typeof match$25 === "number" || match$25.TAG !== /* Kassa */2) {
                  tmp$8 = "";
                } else {
                  const match$26 = match$25._0._0;
                  if (typeof match$26 === "number") {
                    tmp$8 = "";
                  } else {
                    let tmp$9 = match$26._1;
                    if (typeof tmp$9 === "number" || tmp$9.TAG !== /* Journal */2) {
                      tmp$8 = "";
                    } else {
                      kkmId$4 = match$26._0;
                      exit$4 = 1;
                    }
                  }
                }
                break;
            case /* Admin */7 :
                const match$27 = currentRoute._0;
                if (typeof match$27 === "number" || match$27.TAG !== /* Orgs */1) {
                  tmp$8 = "";
                } else {
                  const match$28 = match$27._0;
                  if (typeof match$28 === "number") {
                    tmp$8 = "";
                  } else {
                    const match$29 = match$28._1;
                    if (typeof match$29 === "number" || match$29.TAG !== /* Kassa */2) {
                      tmp$8 = "";
                    } else {
                      const match$30 = match$29._0._0;
                      if (typeof match$30 === "number") {
                        tmp$8 = "";
                      } else {
                        let tmp$10 = match$30._1;
                        if (typeof tmp$10 === "number" || tmp$10.TAG !== /* Journal */2) {
                          tmp$8 = "";
                        } else {
                          kkmId$4 = match$30._0;
                          exit$4 = 1;
                        }
                      }
                    }
                  }
                }
                break;
            default:
              tmp$8 = "";
          }
        }
        if (exit$4 === 1) {
          tmp$8 = kkmId$4 === kkm.id ? "bg-white-8%" : "";
        }
        let tmp$11;
        let exit$5 = 0;
        let kkmId$5;
        if (typeof currentRoute === "number") {
          tmp$11 = "text-gray-medium";
        } else {
          switch (currentRoute.TAG | 0) {
            case /* Org */6 :
                const match$31 = currentRoute._1;
                if (typeof match$31 === "number" || match$31.TAG !== /* Kassa */2) {
                  tmp$11 = "text-gray-medium";
                } else {
                  const match$32 = match$31._0._0;
                  if (typeof match$32 === "number") {
                    tmp$11 = "text-gray-medium";
                  } else {
                    let tmp$12 = match$32._1;
                    if (typeof tmp$12 === "number" || tmp$12.TAG !== /* Journal */2) {
                      tmp$11 = "text-gray-medium";
                    } else {
                      kkmId$5 = match$32._0;
                      exit$5 = 1;
                    }
                  }
                }
                break;
            case /* Admin */7 :
                const match$33 = currentRoute._0;
                if (typeof match$33 === "number" || match$33.TAG !== /* Orgs */1) {
                  tmp$11 = "text-gray-medium";
                } else {
                  const match$34 = match$33._0;
                  if (typeof match$34 === "number") {
                    tmp$11 = "text-gray-medium";
                  } else {
                    const match$35 = match$34._1;
                    if (typeof match$35 === "number" || match$35.TAG !== /* Kassa */2) {
                      tmp$11 = "text-gray-medium";
                    } else {
                      const match$36 = match$35._0._0;
                      if (typeof match$36 === "number") {
                        tmp$11 = "text-gray-medium";
                      } else {
                        let tmp$13 = match$36._1;
                        if (typeof tmp$13 === "number" || tmp$13.TAG !== /* Journal */2) {
                          tmp$11 = "text-gray-medium";
                        } else {
                          kkmId$5 = match$36._0;
                          exit$5 = 1;
                        }
                      }
                    }
                  }
                }
                break;
            default:
              tmp$11 = "text-gray-medium";
          }
        }
        if (exit$5 === 1) {
          tmp$11 = kkmId$5 === kkm.id ? "text-white" : "text-gray-medium";
        }
        let tmp$14;
        if (kkm.state === "linked") {
          let tmp$15;
          let exit$6 = 0;
          let kkmId$6;
          if (typeof currentRoute === "number") {
            tmp$15 = "";
          } else {
            switch (currentRoute.TAG | 0) {
              case /* Org */6 :
                  const match$37 = currentRoute._1;
                  if (typeof match$37 === "number" || match$37.TAG !== /* Kassa */2) {
                    tmp$15 = "";
                  } else {
                    const match$38 = match$37._0._0;
                    if (typeof match$38 === "number") {
                      tmp$15 = "";
                    } else {
                      let tmp$16 = match$38._1;
                      if (typeof tmp$16 === "number" || tmp$16.TAG !== /* Settings */0) {
                        tmp$15 = "";
                      } else {
                        kkmId$6 = match$38._0;
                        exit$6 = 1;
                      }
                    }
                  }
                  break;
              case /* Admin */7 :
                  const match$39 = currentRoute._0;
                  if (typeof match$39 === "number" || match$39.TAG !== /* Orgs */1) {
                    tmp$15 = "";
                  } else {
                    const match$40 = match$39._0;
                    if (typeof match$40 === "number") {
                      tmp$15 = "";
                    } else {
                      const match$41 = match$40._1;
                      if (typeof match$41 === "number" || match$41.TAG !== /* Kassa */2) {
                        tmp$15 = "";
                      } else {
                        const match$42 = match$41._0._0;
                        if (typeof match$42 === "number") {
                          tmp$15 = "";
                        } else {
                          let tmp$17 = match$42._1;
                          if (typeof tmp$17 === "number" || tmp$17.TAG !== /* Settings */0) {
                            tmp$15 = "";
                          } else {
                            kkmId$6 = match$42._0;
                            exit$6 = 1;
                          }
                        }
                      }
                    }
                  }
                  break;
              default:
                tmp$15 = "";
            }
          }
          if (exit$6 === 1) {
            tmp$15 = kkmId$6 === kkm.id ? "bg-white-8%" : "";
          }
          let tmp$18;
          let exit$7 = 0;
          let kkmId$7;
          if (typeof currentRoute === "number") {
            tmp$18 = "text-gray-medium";
          } else {
            switch (currentRoute.TAG | 0) {
              case /* Org */6 :
                  const match$43 = currentRoute._1;
                  if (typeof match$43 === "number" || match$43.TAG !== /* Kassa */2) {
                    tmp$18 = "text-gray-medium";
                  } else {
                    const match$44 = match$43._0._0;
                    if (typeof match$44 === "number") {
                      tmp$18 = "text-gray-medium";
                    } else {
                      let tmp$19 = match$44._1;
                      if (typeof tmp$19 === "number" || tmp$19.TAG !== /* Settings */0) {
                        tmp$18 = "text-gray-medium";
                      } else {
                        kkmId$7 = match$44._0;
                        exit$7 = 1;
                      }
                    }
                  }
                  break;
              case /* Admin */7 :
                  const match$45 = currentRoute._0;
                  if (typeof match$45 === "number" || match$45.TAG !== /* Orgs */1) {
                    tmp$18 = "text-gray-medium";
                  } else {
                    const match$46 = match$45._0;
                    if (typeof match$46 === "number") {
                      tmp$18 = "text-gray-medium";
                    } else {
                      const match$47 = match$46._1;
                      if (typeof match$47 === "number" || match$47.TAG !== /* Kassa */2) {
                        tmp$18 = "text-gray-medium";
                      } else {
                        const match$48 = match$47._0._0;
                        if (typeof match$48 === "number") {
                          tmp$18 = "text-gray-medium";
                        } else {
                          let tmp$20 = match$48._1;
                          if (typeof tmp$20 === "number" || tmp$20.TAG !== /* Settings */0) {
                            tmp$18 = "text-gray-medium";
                          } else {
                            kkmId$7 = match$48._0;
                            exit$7 = 1;
                          }
                        }
                      }
                    }
                  }
                  break;
              default:
                tmp$18 = "text-gray-medium";
            }
          }
          if (exit$7 === 1) {
            tmp$18 = kkmId$7 === kkm.id ? "text-white" : "text-gray-medium";
          }
          tmp$14 = JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                route: Curry._1(contextRoute, {
                      TAG: /* Kassa */2,
                      _0: /* Kkms */{
                        _0: /* Kkm */{
                          _0: kkm.id,
                          _1: {
                            TAG: /* Settings */0,
                            _0: /* General */0
                          }
                        }
                      }
                    }),
                className: Cn.fromList({
                      hd: "px-6 flex py-1.5 items-center",
                      tl: {
                        hd: tmp$15,
                        tl: /* [] */0
                      }
                    }),
                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                      className: Cn.fromList({
                            hd: "ml-9",
                            tl: {
                              hd: tmp$18,
                              tl: /* [] */0
                            }
                          }),
                      children: "Настройки"
                    })
              });
        } else {
          tmp$14 = null;
        }
        return JsxRuntime.jsxs(React.Fragment, {
                    children: [
                      JsxRuntime.jsxs("button", {
                            children: [
                              tmp,
                              JsxRuntime.jsxs(Buhta_components__Text.PSmall.make, {
                                    className: Cn.fromList({
                                          hd: "ml-4 flex justify-between w-full",
                                          tl: {
                                            hd: tmp$1,
                                            tl: /* [] */0
                                          }
                                        }),
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: kkm.name,
                                            className: "truncate text-left w-32"
                                          }),
                                      JsxRuntime.jsx("img", {
                                            className: Cn.fromList({
                                                  hd: "w-5 h-5",
                                                  tl: {
                                                    hd: Cn.on("rotate-180", !kkmMenu),
                                                    tl: /* [] */0
                                                  }
                                                }),
                                            src: StaticAsset.src("/static/icons/arrow-up.svg")
                                          })
                                    ]
                                  })
                            ],
                            className: Cn.fromList({
                                  hd: "px-6 flex py-1.5 items-center",
                                  tl: /* [] */0
                                }),
                            onClick: (function (param) {
                                Curry._1(setKkmMenu, (function (param) {
                                        return !kkmMenu;
                                      }));
                                if (!kkmMenu) {
                                  return Buhta_cabinet__Route.navigateTo(Curry._1(contextRoute, {
                                                  TAG: /* Kassa */2,
                                                  _0: /* Kkms */{
                                                    _0: /* Kkm */{
                                                      _0: kkm.id,
                                                      _1: /* View */3
                                                    }
                                                  }
                                                }));
                                }
                                
                              })
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                    route: Curry._1(contextRoute, {
                                          TAG: /* Kassa */2,
                                          _0: /* Kkms */{
                                            _0: /* Kkm */{
                                              _0: kkm.id,
                                              _1: /* View */3
                                            }
                                          }
                                        }),
                                    className: Cn.fromList({
                                          hd: "px-6 flex py-1.5 items-center",
                                          tl: {
                                            hd: Caml_obj.caml_equal(currentRoute, Curry._1(contextRoute, {
                                                      TAG: /* Kassa */2,
                                                      _0: /* Kkms */{
                                                        _0: /* Kkm */{
                                                          _0: kkm.id,
                                                          _1: /* View */3
                                                        }
                                                      }
                                                    })) ? "bg-white-8%" : "",
                                            tl: /* [] */0
                                          }
                                        }),
                                    children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: Cn.fromList({
                                                hd: "ml-9",
                                                tl: {
                                                  hd: Caml_obj.caml_equal(currentRoute, Curry._1(contextRoute, {
                                                            TAG: /* Kassa */2,
                                                            _0: /* Kkms */{
                                                              _0: /* Kkm */{
                                                                _0: kkm.id,
                                                                _1: /* View */3
                                                              }
                                                            }
                                                          })) ? "text-white" : "text-gray-medium",
                                                  tl: /* [] */0
                                                }
                                              }),
                                          children: "Обзор"
                                        })
                                  }),
                              JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                    route: Curry._1(contextRoute, {
                                          TAG: /* Kassa */2,
                                          _0: /* Kkms */{
                                            _0: /* Kkm */{
                                              _0: kkm.id,
                                              _1: {
                                                TAG: /* Receipts */1,
                                                _0: /* List */0
                                              }
                                            }
                                          }
                                        }),
                                    className: Cn.fromList({
                                          hd: "px-6 flex py-1.5 items-center",
                                          tl: {
                                            hd: tmp$2,
                                            tl: /* [] */0
                                          }
                                        }),
                                    children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: Cn.fromList({
                                                hd: "ml-9",
                                                tl: {
                                                  hd: tmp$5,
                                                  tl: /* [] */0
                                                }
                                              }),
                                          children: "Чеки"
                                        })
                                  }),
                              JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                    route: Curry._1(contextRoute, {
                                          TAG: /* Kassa */2,
                                          _0: /* Kkms */{
                                            _0: /* Kkm */{
                                              _0: kkm.id,
                                              _1: {
                                                TAG: /* Journal */2,
                                                _0: /* Logs */0
                                              }
                                            }
                                          }
                                        }),
                                    className: Cn.fromList({
                                          hd: "px-6 flex py-1.5 items-center",
                                          tl: {
                                            hd: tmp$8,
                                            tl: /* [] */0
                                          }
                                        }),
                                    children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: Cn.fromList({
                                                hd: "ml-9",
                                                tl: {
                                                  hd: tmp$11,
                                                  tl: /* [] */0
                                                }
                                              }),
                                          children: "Журнал"
                                        })
                                  }),
                              tmp$14
                            ],
                            className: Cn.on("hidden", !kkmMenu)
                          })
                    ]
                  });
      };
    };
  };
}

function SidebarKassa$KkmMenu(Props) {
  return Curry._2(make(Props.currentRoute)(Props.org), Props.kkm, Props.contextRoute);
}

const KkmMenu = {
  make: SidebarKassa$KkmMenu
};

function SidebarKassa$KassaLoading(Props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              className: "w-5 h-5 rounded-3xl bg-white-8%"
                            }),
                        JsxRuntime.jsx("div", {
                              className: "w-24 h-6 rounded bg-white-8% ml-4"
                            })
                      ],
                      className: "flex items-center"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              className: "w-5 h-5 rounded-3xl bg-white-8%"
                            }),
                        JsxRuntime.jsx("div", {
                              className: "w-40 h-5 rounded bg-white-8% ml-4"
                            })
                      ],
                      className: "flex items-center mt-6 py-1.5"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              className: "w-5 h-5 rounded-3xl bg-white-8%"
                            }),
                        JsxRuntime.jsx("div", {
                              className: "w-40 h-5 rounded bg-white-8% ml-4"
                            })
                      ],
                      className: "flex items-center py-1.5"
                    })
              ],
              className: "p-6"
            });
}

const KassaLoading = {
  make: SidebarKassa$KassaLoading
};

function make$1(kkms) {
  return function (org) {
    return function (currentRoute) {
      return function (setBar) {
        return function (setPage) {
          return function (lastPage) {
            const jitsu = JitsuReact.useJitsu();
            const match = Buhta_core__Tenant.useTenant(undefined);
            const tenant = match[0];
            const currentUrlStr = Buhta_cabinet__Route.toString(Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined)));
            const contextRoute = function (route) {
              return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
            };
            return JsxRuntime.jsxs(React.Fragment, {
                        children: [
                          JsxRuntime.jsxs("button", {
                                children: [
                                  JsxRuntime.jsx("img", {
                                        className: "w-5 h-5",
                                        src: StaticAsset.src("/static/icons/back-arrow.svg")
                                      }),
                                  JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                                        className: "ml-4 text-white",
                                        children: "Касса"
                                      })
                                ],
                                className: "px-6 mt-8 flex items-center",
                                onClick: (function (param) {
                                    Curry._1(jitsu.analytics.track, "kassa.kkms.back");
                                    Curry._1(setBar, (function (param) {
                                            return "main";
                                          }));
                                  })
                              }),
                          JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
                                route: contextRoute({
                                      TAG: /* Kassa */2,
                                      _0: /* Kkms */{
                                        _0: /* List */1
                                      }
                                    }),
                                className: Cn.fromList({
                                      hd: "px-6 flex py-1.5 mt-6 items-center",
                                      tl: {
                                        hd: Caml_obj.caml_equal(currentRoute, contextRoute({
                                                  TAG: /* Kassa */2,
                                                  _0: /* Kkms */{
                                                    _0: /* List */1
                                                  }
                                                })) ? "bg-white-8%" : "",
                                        tl: /* [] */0
                                      }
                                    }),
                                children: [
                                  Caml_obj.caml_equal(currentRoute, contextRoute({
                                            TAG: /* Kassa */2,
                                            _0: /* Kkms */{
                                              _0: /* List */1
                                            }
                                          })) ? JsxRuntime.jsx("img", {
                                          className: "w-5 h-5",
                                          src: StaticAsset.src("/static/icons/cashbox-white.svg")
                                        }) : JsxRuntime.jsx("img", {
                                          className: "w-5 h-5",
                                          src: StaticAsset.src("/static/icons/cashbox.svg")
                                        }),
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        className: Cn.fromList({
                                              hd: "ml-4",
                                              tl: {
                                                hd: Caml_obj.caml_equal(currentRoute, contextRoute({
                                                          TAG: /* Kassa */2,
                                                          _0: /* Kkms */{
                                                            _0: /* List */1
                                                          }
                                                        })) ? "text-white" : "text-gray-medium",
                                                tl: /* [] */0
                                              }
                                            }),
                                        children: "Все кассы"
                                      })
                                ]
                              }),
                          Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, kkm) {
                                      const match = kkm.state;
                                      switch (match) {
                                        case "linked" :
                                        case "unlinked" :
                                        case "unlinking" :
                                            break;
                                        default:
                                          return null;
                                      }
                                      const Key = String(i);
                                      return JsxRuntime.jsx(SidebarKassa$KkmMenu, {
                                                  currentRoute: currentRoute,
                                                  org: org,
                                                  kkm: kkm,
                                                  contextRoute: contextRoute
                                                }, Key);
                                    }), kkms)),
                          JsxRuntime.jsxs(Buhta_cabinet__Link.make, {
                                route: contextRoute({
                                      TAG: /* Kassa */2,
                                      _0: /* Kkms */{
                                        _0: /* Create */0
                                      }
                                    }),
                                className: Cn.fromList({
                                      hd: "px-6 flex py-1.5",
                                      tl: {
                                        hd: Caml_obj.caml_equal(currentRoute, contextRoute({
                                                  TAG: /* Kassa */2,
                                                  _0: /* Kkms */{
                                                    _0: /* Create */0
                                                  }
                                                })) ? "bg-white-8%" : "",
                                        tl: /* [] */0
                                      }
                                    }),
                                onLinkClicked: (function (param) {
                                    Curry._1(jitsu.analytics.track, "kassa.kkms.add_kassa_sidebar");
                                  }),
                                children: [
                                  Caml_obj.caml_equal(currentRoute, contextRoute({
                                            TAG: /* Kassa */2,
                                            _0: /* Kkms */{
                                              _0: /* Create */0
                                            }
                                          })) ? JsxRuntime.jsx("img", {
                                          className: "w-5 h-5",
                                          src: StaticAsset.src("/static/icons/plus-white-24.svg")
                                        }) : JsxRuntime.jsx("img", {
                                          className: "w-5 h-5",
                                          src: StaticAsset.src("/static/icons/plus-gray-20.svg")
                                        }),
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        className: Cn.fromList({
                                              hd: "ml-4",
                                              tl: {
                                                hd: Caml_obj.caml_equal(currentRoute, contextRoute({
                                                          TAG: /* Kassa */2,
                                                          _0: /* Kkms */{
                                                            _0: /* Create */0
                                                          }
                                                        })) ? "text-white" : "text-gray-medium",
                                                tl: /* [] */0
                                              }
                                            }),
                                        children: "Новая касса"
                                      })
                                ],
                                urlParams: {
                                  hd: [
                                    "return_to",
                                    currentUrlStr
                                  ],
                                  tl: /* [] */0
                                }
                              })
                        ]
                      });
          };
        };
      };
    };
  };
}

function SidebarKassa$KassaMenu(Props) {
  return Curry._4(make$1(Props.kkms)(Props.org), Props.currentRoute, Props.setBar, Props.setPage, Props.lastPage);
}

const KassaMenu = {
  make: SidebarKassa$KassaMenu
};

function make$2(org) {
  return function (currentRoute) {
    return function (setBar) {
      return function (setIsDropdownShown) {
        const match = React.useState(function () {
              return 1;
            });
        const page = match[0];
        const match$1 = React.useState(function () {
              return false;
            });
        const setLastPage = match$1[1];
        const match$2 = Buhta_core__GrpcState.useGrid(Buhta_cabinet__Kassa.KkmManagerService.grid, undefined);
        const dispatch = match$2[1];
        const grid = match$2[0];
        const match$3 = Buhta_cabinet__Kkm.KkmsCtx.use(undefined);
        const dispatchKkms = match$3[1];
        const match$4 = Buhta_core__Auth.IdentityContext.useIdentity(undefined);
        const identity = match$4[0];
        const match$5 = Buhta_core__Tenant.useTenant(undefined);
        const tenant = match$5[0];
        const match$6 = React.useState(function () {
              return false;
            });
        const setIsProfileHovered = match$6[1];
        const isProfileHovered = match$6[0];
        const contextRoute = function (route) {
          return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
        };
        let userpic;
        let exit = 0;
        if (typeof identity === "number" || identity.TAG !== /* Authorized */0) {
          exit = 1;
        } else {
          const identityProfile = identity._0;
          userpic = identityProfile.userpic_url === "" ? JsxRuntime.jsx("div", {
                  children: identityProfile.first_name.substring(0, 1),
                  className: "w-5 h-5 rounded-full bg-asphalt flex justify-center items-center text-white text-xs font-semibold"
                }) : JsxRuntime.jsx("img", {
                  className: "w-5 h-5 rounded-50pct",
                  src: identityProfile.userpic_url
                });
        }
        if (exit === 1) {
          userpic = JsxRuntime.jsx("img", {
                className: "w-5 h-5 rounded-50pct",
                src: StaticAsset.src("/static/icons/profile-photo.png")
              });
        }
        let fullName;
        if (typeof identity === "number" || identity.TAG !== /* Authorized */0) {
          fullName = "Профиль";
        } else {
          const identityProfile$1 = identity._0;
          fullName = identityProfile$1.first_name + (" " + identityProfile$1.last_name);
        }
        React.useEffect((function () {
                const params = {
                  search: undefined,
                  page: page,
                  filters: /* [] */0,
                  expand: /* [] */0
                };
                Curry._3(dispatch, undefined, params, undefined);
              }), [page]);
        React.useEffect((function () {
                if (typeof grid !== "string" && grid.NAME === "Data") {
                  const data = grid.VAL;
                  Curry._1(dispatchKkms, {
                        TAG: /* Replace */1,
                        _0: data
                      });
                  Curry._1(setLastPage, (function (param) {
                          return Stdlib__List.length(data) < 25;
                        }));
                }
                
              }), [grid]);
        return JsxRuntime.jsxs(React.Fragment, {
                    children: [
                      typeof grid === "string" ? (
                          grid === "Loading" ? JsxRuntime.jsx(SidebarKassa$KassaLoading, {}) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
                        ) : (
                          grid.NAME === "Data" ? JsxRuntime.jsx(SidebarKassa$KassaMenu, {
                                  kkms: match$3[0],
                                  org: org,
                                  currentRoute: currentRoute,
                                  setBar: setBar,
                                  setPage: match[1],
                                  lastPage: match$1[0]
                                }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
                        ),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_cabinet__SidebarItem.make, {
                                    item: {
                                      label: "Настройки",
                                      route: contextRoute({
                                            TAG: /* Settings */8,
                                            _0: /* General */0
                                          }),
                                      isActiveRoute: (function (param) {
                                          if (typeof param === "number" || param.TAG !== /* Settings */8) {
                                            return false;
                                          } else {
                                            return true;
                                          }
                                        }),
                                      eventName: "",
                                      bar: "settings",
                                      isHidden: false
                                    },
                                    setBar: setBar
                                  }, "sidebar__item_settings"),
                              JsxRuntime.jsxs("button", {
                                    children: [
                                      userpic,
                                      JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                            className: Cn.fromList({
                                                  hd: "ml-4 truncate",
                                                  tl: {
                                                    hd: isProfileHovered ? "text-white" : "text-gray-medium group-hover:text-white",
                                                    tl: /* [] */0
                                                  }
                                                }),
                                            children: fullName
                                          })
                                    ],
                                    className: Cn.fromList({
                                          hd: "whitespace-nowrap px-6 flex py-1.5 hover:w-full",
                                          tl: {
                                            hd: isProfileHovered ? "bg-white/8" : "hover:bg-white/8",
                                            tl: /* [] */0
                                          }
                                        }),
                                    onClick: (function (param) {
                                        Curry._1(setIsDropdownShown, (function (param) {
                                                return true;
                                              }));
                                      }),
                                    onMouseEnter: (function (param) {
                                        Curry._1(setIsProfileHovered, (function (param) {
                                                return true;
                                              }));
                                      }),
                                    onMouseLeave: (function (param) {
                                        Curry._1(setIsProfileHovered, (function (param) {
                                                return false;
                                              }));
                                      })
                                  })
                            ],
                            className: "absolute bottom-6 space-y-2 w-[244px]"
                          })
                    ]
                  });
      };
    };
  };
}

function SidebarKassa(Props) {
  return Curry._2(make$2(Props.org)(Props.currentRoute), Props.setBar, Props.setIsDropdownShown);
}

const make$3 = SidebarKassa;

export {
  KkmMenu ,
  KassaLoading ,
  KassaMenu ,
  make$3 as make,
}
/* @jitsu/jitsu-react Not a pure module */
